/**
 * @generated SignedSource<<c112d77ad033a9565849ff857a51db41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type teamMemberUserProfileFragment$data = {
  readonly firstName: string;
  readonly lastName: string;
  readonly " $fragmentType": "teamMemberUserProfileFragment";
};
export type teamMemberUserProfileFragment$key = {
  readonly " $data"?: teamMemberUserProfileFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"teamMemberUserProfileFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "teamMemberUserProfileFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "ba0a689eada841b92ee8e2a09ad09e99";

export default node;
